import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-02c2bb18"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-content" }
const _hoisted_2 = { class: "footer-row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SoftwareSelect = _resolveComponent("SoftwareSelect")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createBlock(_component_el_drawer, {
    "append-to-body": "",
    "custom-class": "range-setting-wrap",
    title: _ctx.$t('softwareUsage.rangeSetting'),
    "model-value": _ctx.modelValue,
    "show-close": "",
    size: 700,
    onClose: _ctx.handleClose
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_SoftwareSelect, {
          style: {"overflow":"hidden"},
          modelValue: _ctx.softwareChecked,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.softwareChecked) = $event)),
          popper: false,
          placeholder: _ctx.$t('genuineSoftwareUsage.pleaseSetSoftwareFirst')
        }, null, 8, ["modelValue", "placeholder"]),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_el_button, {
            plain: "",
            size: "small",
            onClick: _ctx.handleClose
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('common.cancel')), 1)
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_el_button, {
            type: "primary",
            size: "small",
            onClick: _ctx.handleConfirm
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('common.confirm')), 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["title", "model-value", "onClose"]))
}